import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { autoRegURLs } from '@personal-area/global/http/models';
import { SocialUser } from '@personal-area/global/social-authorization/models';
import { Role } from '@personal-area/global/users/models';
import { LOCAL_STORAGE, UniversalStorageService } from '@personal-area/storage';

export interface AutoRegErr {
  role: Role;
  email: string;
  tariff: string;
}

const regStatusCookieName = 'front-reg-status';
const regSocialCookieName = 'front-reg-social';
const regErrorCookieName = 'front-reg-error';
const callbackCookieName = 'front-social-callback';

interface RegistrationInfo {
  id: number;
  role: string;
  name: string;
  email: string;
  tariff: string;
  currency: string;
  password: string;
  accountId: number;
  accessToken: string;
  refreshToken: string;
  isAccountCreated: boolean;
  isRegistrationSuccessful: boolean;
}

@Injectable({ providedIn: 'root' })
export class AutoRegistrationService {
  private readonly _localStorage = inject(LOCAL_STORAGE);

  constructor(
    private _http: HttpClient,
    private _storage: UniversalStorageService
  ) {}

  public check(): boolean {
    return this._storage.check(regStatusCookieName);
  }

  public reset(): void {
    this._storage.delete(regStatusCookieName, { path: ' / ', domain: '.' + document.location.host });
    this._storage.delete(regSocialCookieName, { path: ' / ', domain: '.' + document.location.host });
    this._storage.delete(regErrorCookieName, { path: ' / ', domain: '.' + document.location.host });
    this.resetSocialAuthCallback();
  }

  public status(): Observable<RegistrationInfo> {
    return this._http.get<RegistrationInfo>(autoRegURLs.status);
  }

  public checkSocial(): boolean {
    return this._storage.check(regSocialCookieName);
  }

  public checkErrors(): boolean {
    return this._storage.check(regErrorCookieName);
  }

  public getSocialData(): SocialUser {
    return JSON.parse(atob(this._storage.getItem(regSocialCookieName))) as  SocialUser;
  }

  public getAutoRegErrData(): AutoRegErr {
    return JSON.parse(atob(this._storage.getItem(regErrorCookieName))) as  AutoRegErr;
  }

  public get socialAuthCallback(): string {
    if (this._storage.check(callbackCookieName)) {
      return decodeURIComponent(this._storage.getItem(callbackCookieName));
    }

    return this._localStorage.getItem(callbackCookieName) || '';
  }

  public set socialAuthCallback(callback: string) {
    if (callback.startsWith('/cabinet')) {
      // callback = callback.replace('/cabinet', '');
      this._storage.setItem(callbackCookieName, callback, {
        path: '/'
      });
      this._localStorage.setItem(callbackCookieName, callback);
    }
  }

  public resetSocialAuthCallback(): void {
    this._localStorage.removeItem(callbackCookieName);
    this._storage.delete(callbackCookieName, { path: '/', domain: '.' + document.location.host });
  }
}
